
export const cpfFormatter = (value) => {
  const cpf = (`${value}`).replace(/\D/, '')
  return cpf.replace(/^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/, '$1.$2.$3-$4')
}

export const telefoneFormatter = (value) => {
  const telefone = (`${value}`).replace(/\D/, '')
  switch (telefone.length) {
    case 11:
      return telefone.replace(
        /^([0-9]{2})([0-9]{5})([0-9]{4})/,
        '($1) $2-$3'
      )
    case 9:
      return telefone.replace(
        /^([0-9]{5})([0-9]{4})/,
        '$1-$2'
      )
    case 10:
      return telefone.replace(
        /^([0-9]{2})([0-9]{4})([0-9]{4})/,
        '($1) $2-$3'
      )
    default:
      return telefone.replace(
        /^([0-9]{4})([0-9]{4})/,
        '$1-$2'
      )
  }
}
